import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./App";
import ProjectDetail from "./pages/ProjectDetail";

const AppRoutes = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/projeto/:slug" element={<ProjectDetail />} />
    </Routes>
  </BrowserRouter>
);

export default AppRoutes;
